import React, { useState } from "react";
import ButtonIcon from "../../components/ButtonIcon";

export default function NestedDataTableRow(props) {
  const [toggleItem, setToggleItem] = useState(false);

  return (
    <div>
      <div className="table-row">
        <div
          className="table-data-row"
          onClick={() => {
            props.openCompanyFunction(props.data.idEmpresa);
          }}
        >
          <div className="table-row-item">
            <button
              className="toggle-icon"
              onClick={(e) => {
                e.stopPropagation();
                setToggleItem(!toggleItem);
              }}
            >
              <img
                src={
                  toggleItem
                    ? "/images/arrow-up-blue.svg"
                    : "/images/arrow-down-blue.svg"
                }
                loading="lazy"
                alt="Icon"
                className="section-header-icon"
              ></img>
            </button>
          </div>
          <span className="table-row-item size1">{props.data.idEmpresa}</span>
          <span className="table-row-item size2">{props.data.NIF}</span>
          <span className="table-row-item size4">
            {props.data.nombre_empresa}
          </span>
          <span className="table-row-item size4">{props.data.direccion}</span>
          <span className="table-row-item size2">
            {props.data.telefono_fijo}
          </span>
          <span className="table-row-item size2">
            {props.data.telefono_movil}
          </span>
          <span className="table-row-item size3">{props.data.email}</span>
          <div className="table-row-item">
            <ButtonIcon
              text="Nueva Óptica"
              icon="/images/add-white.svg"
              onClick={(e) => {
                e.stopPropagation();
                props.newOpticFunction(props.data.idEmpresa);
              }}
            ></ButtonIcon>
          </div>
        </div>
      </div>
      {toggleItem && (
        <div>
          <div className="nested-table-header">
            <span className="nested-table-header-item size1"> </span>
            {props.nestedColumns.map((col) => {
              return (
                <span
                  key={col.name}
                  className={"nested-table-header-item " + col.size}
                >
                  {col.name}
                </span>
              );
            })}
          </div>
          {props.data.opticas.map((opt) => {
            return (
              <div key={opt.idOptica}>
                <div className="table-row">
                  <div
                    className="nested-table-data-row"
                    onClick={() => {
                      props.openOpticFunction(opt.idOptica);
                    }}
                  >
                    <span className="table-row-item size1"></span>
                    <span className="table-row-item size1">{opt.idOptica}</span>
                    <span className="table-row-item size4">{opt.nombre}</span>
                    <span className="table-row-item size4">
                      {opt.nombre_corto}
                    </span>
                    <span className="table-row-item size2">{opt.telefono}</span>
                    <span className="table-row-item size2">{opt.movil}</span>
                    <span className="table-row-item size3">{opt.email}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
